// OPTION SETS FROM EXCEL SHEET (06_DROPDOWNS)

export const INDUSTRY_OPTIONS = [
  { value: "Oil & Gas", label: "Oil & Gas" },
  { value: "Marine & Offshore", label: "Marine & Offshore" },
  { value: "Infrastructure", label: "Infrastructure" },
  { value: "Manufacturing", label: "Manufacturing" },
  { value: "Energy & Renewables", label: "Energy & Renewables" },
  { value: "Logistics & Yard Operations", label: "Logistics & Yard Operations" },
  { value: "Quality, Inspection & Compliance", label: "Quality, Inspection & Compliance" },
];

export const SCOPE_OPTIONS = {
  "Oil & Gas": [
    { value: "Line Pipe Manufacturing", label: "Line Pipe Manufacturing" },
    { value: "Welding & Fabrication", label: "Welding & Fabrication" },
    { value: "Pressure Equipment", label: "Pressure Equipment" },
    { value: "Pipeline Construction", label: "Pipeline Construction" },
    { value: "Coating & Corrosion", label: "Coating & Corrosion" },
    { value: "NDT Surveillance", label: "NDT Surveillance" },
  ],
  "Marine & Offshore": [
    { value: "Marine Warranty Survey", label: "Marine Warranty Survey" },
    { value: "Offshore Vessel Inspection", label: "Offshore Vessel Inspection" },
    { value: "Subsea / Offshore Inspection", label: "Subsea / Offshore Inspection" },
    { value: "Hull, Structure & Machinery", label: "Hull, Structure & Machinery" },
    { value: "Rope Access Inspection", label: "Rope Access Inspection" },
  ],
  "Infrastructure": [
    { value: "Civil Works", label: "Civil Works" },
    { value: "Structural Steel", label: "Structural Steel" },
    { value: "Bridges & Heavy Structures", label: "Bridges & Heavy Structures" },
    { value: "MEP Services", label: "MEP Services" },
    { value: "Safety & Compliance", label: "Safety & Compliance" },
  ],
  "Manufacturing": [
    { value: "Vendor Inspection", label: "Vendor Inspection" },
    { value: "Factory Acceptance Test", label: "Factory Acceptance Test" },
    { value: "Dimensional Inspection", label: "Dimensional Inspection" },
    { value: "Welding & Fabrication", label: "Welding & Fabrication" },
    { value: "Coating & Finishing", label: "Coating & Finishing" },
    { value: "Packing & Dispatch", label: "Packing & Dispatch" },
  ],
  "Energy & Renewables": [
    { value: "Solar Projects", label: "Solar Projects" },
    { value: "Wind Projects", label: "Wind Projects" },
    { value: "Offshore Wind", label: "Offshore Wind" },
    { value: "Battery Energy Storage", label: "Battery Energy Storage" },
    { value: "Green Hydrogen / Energy Equipment", label: "Green Hydrogen / Energy Equipment" },
    { value: "Blade / Tower Access Inspection", label: "Blade / Tower Access Inspection" },
  ],
  "Logistics & Yard Operations": [
    { value: "Yard Receiving Inspection", label: "Yard Receiving Inspection" },
    { value: "Cargo Handling Survey", label: "Cargo Handling Survey" },
    { value: "Container Inspection", label: "Container Inspection" },
    { value: "Port Operations", label: "Port Operations" },
    { value: "Storage & Preservation", label: "Storage & Preservation" },
    { value: "International Container Safety", label: "International Container Safety" },
  ],
  "Quality, Inspection & Compliance": [
    { value: "Third-Party Inspection Management", label: "Third-Party Inspection Management" },
    { value: "Supplier / Vendor Audits", label: "Supplier / Vendor Audits" },
    { value: "QA/QC Documentation", label: "QA/QC Documentation" },
    { value: "Compliance Support", label: "Compliance Support" },
    { value: "NCR / CAR Management", label: "NCR / CAR Management" },
    { value: "HSE Compliance", label: "HSE Compliance" },
  ],
};

export const GENDER_OPTIONS = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "Other", label: "Other" },
  { value: "Prefer not to say", label: "Prefer not to say" },
];

export const CAREER_STAGE_OPTIONS = [
  { value: "Aspirant / Graduate", label: "Aspirant / Graduate" },
  { value: "Trainee Surveyor", label: "Trainee Surveyor" },
  { value: "Junior Surveyor", label: "Junior Surveyor" },
  { value: "Independent Surveyor", label: "Independent Surveyor" },
  { value: "Senior / Lead Surveyor", label: "Senior / Lead Surveyor" },
  { value: "Principal / Authority", label: "Principal / Authority" },
];

export const AVAILABILITY_STATUS_OPTIONS = [
  { value: "Available immediately", label: "Available immediately" },
  { value: "Available from date", label: "Available from date" },
  { value: "Serving notice", label: "Serving notice" },
  { value: "Currently engaged", label: "Currently engaged" },
  { value: "Unavailable", label: "Unavailable" },
  { value: "Open to discussion", label: "Open to discussion" },
];

export const ENGAGEMENT_TYPE_OPTIONS = [
  { value: "Permanent", label: "Permanent" },
  { value: "Fixed-term contract", label: "Fixed-term contract" },
  { value: "Day-rate contract", label: "Day-rate contract" },
  { value: "Hourly contract", label: "Hourly contract" },
  { value: "Project-based", label: "Project-based" },
  { value: "Rotation", label: "Rotation" },
  { value: "Freelance / Independent", label: "Freelance / Independent" },
];

export const RATE_TYPE_OPTIONS = [
  { value: "Monthly", label: "Monthly" },
  { value: "Daily", label: "Daily" },
  { value: "Hourly", label: "Hourly" },
  { value: "Per assignment", label: "Per assignment" },
  { value: "Per project", label: "Per project" },
];

export const CURRENCY_OPTIONS = [
  { value: "INR", label: "INR (₹)" },
  { value: "USD", label: "USD ($)" },
  { value: "EUR", label: "EUR (€)" },
  { value: "GBP", label: "GBP (£)" },
  { value: "AED", label: "AED (د.إ)" },
  { value: "SAR", label: "SAR (ر.س)" },
  { value: "SGD", label: "SGD (S$)" },
  { value: "AUD", label: "AUD (A$)" },
];

export const LANGUAGE_PROFICIENCY_OPTIONS = [
  { value: "Basic", label: "Basic" },
  { value: "Working", label: "Working" },
  { value: "Professional", label: "Professional" },
  { value: "Fluent", label: "Fluent" },
  { value: "Native / bilingual", label: "Native / bilingual" },
];

export const APPROVAL_STATUS_OPTIONS = [
  { value: "DRAFT", label: "DRAFT" },
  { value: "ACTIVE", label: "ACTIVE" },
  { value: "REVOKED", label: "REVOKED" },
  { value: "EXPIRED", label: "EXPIRED" },
  { value: "ARCHIVED", label: "ARCHIVED" },
];

// Country options use ISO 3166-1 alpha-2 codes as the `value` so they can
// be sent directly to model fields validated with validate_iso_country_code
// (e.g. ProfessionalProfile.country_of_residence). `label` stays the
// human-readable country name for display.
export const COUNTRY_OPTIONS = [
  { value: "IN", label: "India" },
  { value: "US", label: "United States" },
  { value: "GB", label: "United Kingdom" },
  { value: "AU", label: "Australia" },
  { value: "AE", label: "United Arab Emirates" },
  { value: "SA", label: "Saudi Arabia" },
  { value: "SG", label: "Singapore" },
  { value: "MY", label: "Malaysia" },
  { value: "CN", label: "China" },
  { value: "JP", label: "Japan" },
  { value: "KR", label: "South Korea" },
  { value: "FR", label: "France" },
  { value: "DE", label: "Germany" },
  { value: "IT", label: "Italy" },
];

// Helper functions for creating empty records
export const createEmptyEducation = () => ({
  id: `edu-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  qualification: "",
  discipline: "",
  institute: "",
  country: "",
  start_date: "",
  end_date: "",
  grade: "",
  certificate_file: null,
  file_name: "",
  errors: {},
});

export const createEmptyCertification = () => ({
  id: `cert-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  body: "",
  certification: "",
  level: "",
  number: "",
  issue_date: "",
  expiry_date: "",
  status: "Active",
  linked_scope: "",
  certificate_file: null,
  file_name: "",
  errors: {},
});

export const createEmptyTraining = () => ({
  id: `training-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  course_name: "",
  provider: "",
  start_date: "",
  end_date: "",
  expiry_date: "",
  certificate_file: null,
  file_name: "",
  errors: {},
});

export const createEmptyEmployment = () => ({
  id: `emp-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  employer: "",
  title: "",
  employment_type: "",
  location: "",
  country: "",
  start_date: "",
  end_date: "",
  is_current: false,
  duties: "",
  evidence_file: null,
  file_name: "",
  errors: {},
});

export const createEmptyProject = () => ({
  id: `proj-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  project_name: "",
  client_name: "",
  client_visibility: "SHOW_CLIENT_NAME",
  employer: "",
  location: "",
  country: "",
  start_date: "",
  end_date: "",
  is_current: false,
  role: "",
  industry_id: null,
  industry_label: "",
  scope_ids: [],
  scope_field_values: {},
  responsibilities: "",
  achievements: "",
  allocation_percent: 100,
  verified_field_days: 0,
  is_primary: false,
  codes_standards: [],
  evidence_file: null,
  file_name: "",
  errors: {},
});

export const createEmptyVisa = () => ({
  id: `visa-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  country: "",
  visa_type: "",
  visa_number: "",
  issue_date: "",
  expiry_date: "",
  errors: {},
});

export const createEmptyCDC = () => ({
  id: `cdc-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  number: "",
  issuing_country: "",
  issue_date: "",
  expiry_date: "",
  errors: {},
});

export const createEmptyCoC = () => ({
  id: `coc-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  number: "",
  grade: "",
  issuing_authority: "",
  issue_date: "",
  expiry_date: "",
  endorsements: "",
  errors: {},
});

export const createEmptyLanguage = () => ({
  id: `lang-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  language: "",
  speaking: "",
  reading: "",
  writing: "",
  errors: {},
});

export const createEmptyEmergencyContact = () => ({
  id: `emergency-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  full_name: "",
  relationship: "",
  phone: "",
  email: "",
  errors: {},
});

export const createEmptyMedicalFitness = () => ({
  id: `medical-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  fitness_type: "",
  provider: "",
  status: "",
  issue_date: "",
  expiry_date: "",
  restrictions: "",
  errors: {},
});

export const MEMBERSHIP_STATUS_OPTIONS = [
  { value: "Active", label: "Active" },
  { value: "Lapsed", label: "Lapsed" },
  { value: "Honorary", label: "Honorary" },
  { value: "Pending", label: "Pending" },
];

export const createEmptyMembership = () => ({
  id: `membership-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  body_institution: "",
  grade: "",
  membership_number: "",
  start_date: "",
  status: "",
  errors: {},
});

export const createEmptyPublication = () => ({
  id: `publication-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  title: "",
  publisher: "",
  date: "",
  url: "",
  errors: {},
});

export const createEmptyAward = () => ({
  id: `award-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  award_name: "",
  issuer: "",
  date: "",
  reason_context: "",
  errors: {},
});

export const COMPETENCY_PROFICIENCY_OPTIONS = [
  { value: "Aware", label: "Aware" },
  { value: "Supervised", label: "Supervised" },
  { value: "Independent", label: "Independent" },
  { value: "Expert", label: "Expert" },
];

// Form's CONSENT_OPTIONS values -> backend boolean. Adjust the keys below
// if your CONSENT_OPTIONS uses different labels (check constants.js).
export const CONSENT_MAP = {
  Yes: true,
  No: false,
};

export const CALIBRATION_AUTHORITY_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
  { value: "Not applicable", label: "Not applicable" },
];

export const createEmptyStandard = () => ({
  id: `std-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  standard: "",
  edition: "",
  proficiency: "",
  last_used: "",
  errors: {},
});

export const createEmptyEquipment = () => ({
  id: `equip-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  instrument_name: "",
  make_model: "",
  proficiency: "",
  last_used: "",
  calibration_authority: "",
  errors: {},
});

export const createEmptySoftware = () => ({
  id: `sw-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  software_name: "",
  proficiency: "",
  years_of_use: "",
  last_used: "",
  errors: {},
});

export const CONSENT_OPTIONS = [
  { value: "Yes", label: "Yes" },
  { value: "No", label: "No" },
];

export const createEmptyReference = () => ({
  id: `ref-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  name: "",
  job_title: "",
  organisation: "",
  relationship: "",
  email: "",
  phone: "",
  consent_to_share: "",
  errors: {},
});

export const createEmptyClientApproval = () => ({
  id: `client-approval-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
  client_name: "",
  role_scope_approved_for: "",
  related_project: "",
  approval_number: "",
  approval_date: "",
  expiry_date: "",
  status: "Approved",
  evidence_file: null,
  file_name: "",
  errors: {},
});